import {
  QUICK_START_GUIDE_SUPPORT_ITEMS,
  type QuickStartGuideSupportContact,
} from '@efdigital/ll-xceed-v2/data/coaching/coachee/quick-start-guide';
import type { TOC } from '@ember/component/template-only';

import QuickStartGuideSupportHelpCard from './quick-start-guide-support-help-card.gts';

interface QuickStartGuideSupportContactsSignature {
  Args: {
    // Defaults to the coachee support contacts; the coach guide passes its own.
    items?: QuickStartGuideSupportContact[];
  };
  Element: HTMLElement;
}

const QuickStartGuideSupportContacts: TOC<QuickStartGuideSupportContactsSignature> =
  <template>
    <section
      class="row g-4 g-lg-5 align-items-stretch pt-2"
      aria-labelledby="quick-start-support-heading"
      ...attributes
    >
      <div class="col-lg-8">
        <div class="card border shadow-sm rounded-4 h-100">
          <div class="card-body p-4 p-lg-5">
            <h2 class="h5 fw-bold mb-2" id="quick-start-support-heading">
              Support
            </h2>
            <p class="text-body-secondary small mb-4 mb-lg-5">
              Reach the right team for program questions, platform help, and
              urgent session issues.
            </p>

            <ul class="list-unstyled d-flex flex-column gap-3 mb-0">
              {{#each
                (if @items @items QUICK_START_GUIDE_SUPPORT_ITEMS)
                as |contact|
              }}
                <li>
                  <div
                    class="d-flex align-items-start gap-3 p-3 p-md-4 bg-body rounded-4 h-100"
                  >
                    <span
                      class="ll-avatar-xs rounded-circle text-bg-primary d-inline-flex align-items-center justify-content-center flex-shrink-0"
                      aria-hidden="true"
                    >
                      <iconify-icon
                        inline
                        icon={{contact.icon}}
                        class="fs-5"
                        aria-hidden="true"
                      />
                    </span>

                    <div class="min-w-0">
                      <h3 class="h6 fw-semibold mb-1">{{contact.label}}</h3>
                      <p
                        class="small text-body-secondary mb-0"
                      >{{contact.detail}}</p>
                      {{#if contact.email}}
                        <a
                          href="mailto:{{contact.email}}"
                          class="link-primary text-decoration-none fw-semibold small"
                        >{{contact.email}}</a>
                      {{/if}}
                    </div>
                  </div>
                </li>
              {{/each}}
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <QuickStartGuideSupportHelpCard />
      </div>
    </section>
  </template>;

export default QuickStartGuideSupportContacts;
